import { createFileRoute } from "@tanstack/react-router"
import { TransactionDetailPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/transactions/$transactionUuid"
)({
  component: () => (
    <AuthorizationGate resource={Resource.PAYMENT} action={Action.READ}>
      <TransactionDetailPage />
    </AuthorizationGate>
  ),
})
